export default {
    title: 'Mag travel',
    server: true,
    dev: DEV,
    login: false,
    masterAgentSettings: {}
}
